import React, { useEffect } from 'react'

type PageTitleProps = {
  value: string
}

export const PageTitle: React.FC<PageTitleProps> = ({ value }) => {
  useEffect(() => {
    document.title = `${value} | HC Portal`

    return () => {
      document.title = 'HC Portal'
    }
  }, [value])

  return <></>
}